import * as Yup from "yup";

export const LoginSchema = Yup.object({
  email: Yup.string()
    .email("Please Enter Valid Email Id")
    .required("Email required")
    .matches(
      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
      "Please Enter Valid Email Id"
    ),
  password: Yup.string()
    .required("Please enter your password")
    .min(8, "Password should be between 8-15 characters long")
    .max(25, "Password should be between 8-15 characters long")
    .matches(/[a-zA-Z]/, "Password can only contain Latin letters."),
});

export const contactSchema = Yup.object({
  email: Yup.string()
    .email("Please Enter Valid Email Id")
    .required("Email required")
    .matches(
      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
      "Please Enter Valid Email Id"
    ),
  name: Yup.string().required("Name is required"),
  subject: Yup.string().required("Subject is required"),
  message: Yup.string().required("Message is required"),
});

export const changePasswordSchema = Yup.object({
  oldpassword: Yup.string().required("Old Password is required"),
  newpassword: Yup.string()
    .required("New Password is required")
    .min(8, "Password should be between 8-15 characters long")
    .max(25, "Password should be between 8-15 characters long")
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+])\S{8,}$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
    ),
  confirmpassword: Yup.string()
    .required()
    .oneOf(
      [Yup.ref("newpassword"), null],
      "New Password and Confirm Password does not match"
    )
    .required("Confirm Password is required"),
});

export const forgetPasswordSchema = Yup.object({
  email: Yup.string()
    .email("Please Enter Valid Email")
    .required("Email required")
    .matches(
      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
      "Please Enter Valid Email Id"
    ),
});

export const resetPasswordSchema = Yup.object({
  newpassword: Yup.string()
    .required("New Password is required")
    .min(8, "Password should be between 8-15 characters long")
    .max(25, "Password should be between 8-15 characters long")
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+])\S{8,}$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
    ),
  confirmpassword: Yup.string()
    .required()
    .oneOf(
      [Yup.ref("newpassword"), null],
      "New Password and Confirm Password does not match"
    )
    .required("Confirm Password is required"),
});

export const UserDetailsSchema = (email, tele) =>
  Yup.object({
    UserEmail: Yup.string()
      .email("Invalid email address")
      .required("Email is required!")
      .matches(
        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
        "Please Enter Valid Email Id"
      ),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    experience: Yup.number()
      .required("Years of Experience is required")
      .min(0)
      .max(100),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    user_type: Yup.string().required("User Type is required"),
    user_role: Yup.string().required("User role is required"),
    badge_status: Yup.string().required(" Badge is required"),
    agent_email: email
      ? Yup.string()
          .email("Please Enter Valid Agent Email Id")
          .matches(
            /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
            "Please Enter Valid Email Id"
          )
      : Yup.string(),
    agent_telephone: tele
      ? Yup.string()
          .matches(/^[0-9]+$/, "Telephone must contain only numbers")
          .max(10, "Telephone must not exceed 10 numbers")
      : Yup.string(),
    // agent_name: value? Yup.string() : Yup.string(),
    // uploadimg:Yup.string().required("Please Select Image type of PNG, JPG, JPEG & BMP"),
    // email : Yup.string().required("Email is required"),
    // gender: Yup.string().required("Gender is required"),
    // chosenLanguage: Yup.array().min(1, 'Provide at least one language ').of(Yup.object()),
    // chosenVoice: Yup.array().min(1, 'Provide at least one Voice Type ').of(Yup.object()),
    // facebook: Yup.string().required(" Facebook Username is required"),
    // instagram:Yup.string().required(" Instagram Username is required"),
    // website: Yup.string().required(" Website URL is required"),
    // agency_name: value?Yup.string().required(" Agency Name is required"): Yup.string(),
    // website1: value?Yup.string().required(" Agent Website is required"): Yup.string(),
    // agent_address: value?Yup.string().required("Agent Address is required"): Yup.string(),
    // specialityChosen: Yup.array().min(1, 'Provide at least one speciality after selecting User Type').of(Yup.object()),
    // union: Yup.string().required(" Union is required"),
    // home_studio: Yup.string().required(" Home Studio required"),
    // chosenConnectivity: Yup.array().min(1, 'Provide at least one connectivity ').of(Yup.object()),
    // discoverable: Yup.string().required(" Discoverable is required"),
  });

export const NewsDetailsSchema = () =>
  Yup.object().shape({
    image: Yup.mixed()
      .required("Image is required")
      .test("fileType", "Please upload an image file", (value) => {
        if (!value || (value && typeof value === "string")) return true;
        return value instanceof Blob && value.type?.startsWith("image/");
      }),
    title: Yup.string().required("Title is required"),
    link: Yup.string().matches(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=]*)/,
      "Enter Http/s & www Url Link only!"
    ),
    content: Yup.string().required("Content is required"),
  });

export const EventDetailsSchema = () =>
  Yup.object().shape({
    image: Yup.mixed()
      .required("Image is required")
      .test("fileType", "Please upload an image file", (value) => {
        if (!value || (value && typeof value === "string")) return true;
        return value instanceof Blob && value.type?.startsWith("image/");
      }),
    name: Yup.string().required("Event Name is required"),
    status: Yup.string().required("Status is required"),
    date: Yup.string().required("Event Date is required"),
    time: Yup.string().required("Event Time is required"),
    location: Yup.string().required("Event location is required"),
    description: Yup.string().required("Event Description is required! "),
    chosenMembers: Yup.array().of(Yup.object()),
  });

export const EventSchema = () =>
  Yup.object().shape({
    image: Yup.mixed()
      .required("Image is required")
      .test("fileType", "Please upload an image file", (value) => {
        if (!value || (value && typeof value === "string")) return true;
        return value instanceof Blob && value.type?.startsWith("image/");
      }),
  });

export const ProfileSettingSchema = (tele) =>
  Yup.object().shape({
    profile_pic: Yup.mixed()
      .required("Image is required")
      .test(
        "resolution",
        "Invalid image resolution, Please Upload Image with (300w X 280h) Resolution",
        async (value) => {
          if (!value || (value && typeof value == "string")) return true; // Allow empty values

          return new Promise((resolve) => {
            const reader = new FileReader();

            reader.onload = (event) => {
              const img = new Image();
              img.src = event.target.result;

              img.onload = () => {
                const maxWidth = 300; // Define your maximum width
                const maxHeight = 280; // Define your maximum height

                const validResolution =
                  img.width <= maxWidth && img.height <= maxHeight;

                resolve(validResolution);
              };
            };
            reader.readAsDataURL(value);
          });
        }
      ),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    experience: Yup.string().required("Years of Experience is required"),
    gender: Yup.string().required("Gender is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required!")
      .matches(
        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
        "Please Enter Valid Email Id"
      ),
    telephone: tele
      ? Yup.string()
          .matches(/^[0-9]+$/, "Telephone must contain only numbers")
          .max(10, "Telephone must not exceed 10 numbers")
      : Yup.string(),
  });

export const BadgeSchema = () =>
  Yup.object({
    userId: Yup.number().required("User is required"),
    color: Yup.string().required("Color is required"),
    title: Yup.string().test(
      "characterLimit",
      "Character limit exceeded (220 characters)",
      (value) => {
        if (!value) return true; // Allow empty values
        return value.length <= 220;
      }
    ),
    category: Yup.string().required("Category is required"),
  });

export const SponsorSchema = (previewImg) =>
  Yup.object().shape({
    image: previewImg
      ? Yup.mixed().test(
          "resolution",
          "Invalid image resolution, Please Upload Image with (250w X 50h) Resolution",
          async (value) => {
            if (!value || (value && typeof value == "string")) return true; // Allow empty values

            return new Promise((resolve) => {
              const reader = new FileReader();

              reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                  const maxWidth = 250; // Define your maximum width
                  const maxHeight = 50; // Define your maximum height

                  const validResolution =
                    img.width <= maxWidth && img.height <= maxHeight;

                  resolve(validResolution);
                };
              };

              reader.readAsDataURL(value);
            });
          }
        )
      : Yup.mixed()
          .required("Image is required")
          .test(
            "resolution",
            "Invalid image resolution, Please Upload Image with (250w X 50h) Resolution",
            async (value) => {
              if (!value || (value && typeof value == "string")) return true; // Allow empty values

              return new Promise((resolve) => {
                const reader = new FileReader();

                reader.onload = (event) => {
                  const img = new Image();
                  img.src = event.target.result;

                  img.onload = () => {
                    const maxWidth = 250; // Define your maximum width
                    const maxHeight = 50; // Define your maximum height

                    const validResolution =
                      img.width <= maxWidth && img.height <= maxHeight;

                    resolve(validResolution);
                  };
                };

                reader.readAsDataURL(value);
              });
            }
          ),
    link: Yup.string().matches(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=]*)/,
      "Enter Http/s & www Url Link only!"
    ),
    // link: Yup.string()
    //   .matches(
    //     /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=]*)/,
    //     "Please Enter Valid Link with http/s & www url links only"
    //   )
    //   .nullable() // Allows null values (e.g., empty)
    //   .default(""),
  });

export const specialities = () =>
  Yup.object({
    special: Yup.number().required(""),
    color: Yup.string().required("Color is required"),
    title: Yup.string()
      .test(
        "characterLimit",
        "Character limit exceeded (220 characters)",
        (value) => {
          if (!value) return true; // Allow empty values
          return value.length <= 220;
        }
      )
      .required("Title must be "),
    category: Yup.string().required("Category is required"),
  });

export const specialitySchema = () =>
  Yup.object({
    specialities: Yup.string()
      .test(
        "characterLimit",
        "Character limit exceeded (30 characters)",
        (value) => {
          if (!value) return true; // Allow empty values
          return value.length <= 30;
        }
      )
      .required("speciality is required"),
  });

export const voicetypeSchema = () =>
  Yup.object({
    voicetype: Yup.string()
      .test(
        "characterLimit",
        "Character limit exceeded (30 characters)",
        (value) => {
          if (!value) return true; // Allow empty values
          return value.length <= 30;
        }
      )
      .required("Voice-type name is required"),
  });

export const voicelanguageSchema = () =>
  Yup.object({
    voicelanguage: Yup.string()
      .test(
        "characterLimit",
        "Character limit exceeded (30 characters)",
        (value) => {
          if (!value) return true; // Allow empty values
          return value.length <= 30;
        }
      )
      .required("Voice-language is required"),
  });

export const connectivitySchema = () =>
  Yup.object({
    connectivity: Yup.string()
      .test(
        "characterLimit",
        "Character limit exceeded (30 characters)",
        (value) => {
          if (!value) return true; // Allow empty values
          return value.length <= 30;
        }
      )
      .required(" User Connectivity is required"),
  });

export const RoleManagementSchema = () =>
  Yup.object({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email("Please Enter Valid Email")
      .required("Email required")
      .matches(
        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
        "Please Enter Valid Email Id"
      ),
  });

export const InAppPurchase = () => Yup.object({});
